export function getTitle(dest: string) {
  return `${dest}으로\n언제 출발할까요?`;
}
